import React from "react";
import { APP_PREFIX_PATH } from "configs/AppConfig";

export const adminModuleRoutes = [
	{
		key: "permission-manage",
		exact: true,
		path: `${APP_PREFIX_PATH}/admin/permission/manage`,
		component: React.lazy(() => import("views/admin-views/administration/permission/pages/permssion-manage")),
	},
	{
		key: "desk-admin-manage",
		exact: true,
		path: `${APP_PREFIX_PATH}/admin/desk/manage`,
		component: React.lazy(() => import("views/admin-views/administration/permission/pages/desk-admin-management")),
	},
	{
		key: "desk-admin-create",
		exact: true,
		path: `${APP_PREFIX_PATH}/admin/desk/create`,
		component: React.lazy(() => import("views/admin-views/administration/permission/pages/desk-admin-create")),
	},
	{
		key: "desk-admin-update",
		exact: true,
		path: `${APP_PREFIX_PATH}/admin/desk/update/:id`,
		component: React.lazy(() => import("views/admin-views/administration/permission/pages/desk-admin-update")),
	},
	{
		key: "device-registration",
		exact: true,
		path: `${APP_PREFIX_PATH}/admin/device/`,
		component: React.lazy(() => import("views/admin-views/administration/permission/pages/devices")),
	},
	{
		key: "request-approval-groups",
		exact: true,
		path: `${APP_PREFIX_PATH}/admin/user-groups`,
		component: React.lazy(() => import("views/admin-views/administration/user-groups/pages/Groups")),
	},
	{
		key: "request-approval-groups-create",
		exact: true,
		path: `${APP_PREFIX_PATH}/admin/user-groups/create`,
		component: React.lazy(() => import("views/admin-views/administration/user-groups/pages/CreateGroup")),
	},
	{
		key: "request-approval-groups-users",
		exact: true,
		path: `${APP_PREFIX_PATH}/admin/user-groups/view-users/:id`,
		component: React.lazy(() => import("views/admin-views/administration/user-groups/pages/ViewGroupUsers")),
	},
	{
		key: "supervisors-list",
		exact: true,
		path: `${APP_PREFIX_PATH}/admin/supervisors`,
		component: React.lazy(() => import("views/admin-views/administration/supervisors/pages/SupervisorsList")),
	},
	{
		key: "supervisors-create",
		exact: true,
		path: `${APP_PREFIX_PATH}/admin/supervisors/new`,
		component: React.lazy(() => import("views/admin-views/administration/supervisors/pages/CreateSupervisor")),
	},
	{
		key: "supervisors-view-more",
		exact: true,
		path: `${APP_PREFIX_PATH}/admin/supervisors/view-more/:id`,
		component: React.lazy(() => import("views/admin-views/administration/supervisors/pages/ViewSupervisorDetail")),
	},
	{
		key: "user-list",
		exact: true,
		path: `${APP_PREFIX_PATH}/admin/users`,
		component: React.lazy(() => import("views/admin-views/administration/user-management/pages/UserManagementList")),
	},
];
